
export const FLAGS = Object.freeze({
	USE_SSE_STREAMING: true,
});
